export type PrizeSheetSearch = {
  concurso?: number
}

/**
 * Espelha `features/store/lib/storeSheetSearch`.
 *
 * Idempotente porque o router reparseia o retorno depois de gravar na URL —
 * mesmo contrato de `/feed?post=` e `/lojinha?reward=&item=`.
 *
 * O parâmetro se chama `concurso` e não `prize`: quem vê a URL é o
 * participante, e o rótulo dele é esse. O endereço da rota segue `/sorteios`
 * porque já circula em QR code impresso — é o único lugar onde o nome antigo
 * permanece.
 */
export const validatePrizeSheetSearch = (
  search: Record<string, unknown>
): PrizeSheetSearch => ({
  concurso: Number(search.concurso) || undefined
})

export const buildPrizeSheetSearch = (prizeId: number): PrizeSheetSearch => ({
  concurso: prizeId
})

export const buildPrizeSheetHref = (prizeId: number) =>
  `/sorteios?concurso=${prizeId}`

export const isPrizeSheetSearchActive = (search: PrizeSheetSearch) =>
  typeof search.concurso === 'number'

export const clearPrizeSheetSearch = (): PrizeSheetSearch => ({
  concurso: undefined
})
